export default class AddToCartButton {
  constructor(el) {
    this.states = {
      default: 'addtocart-button-active',
      loading: 'addtocart-button-loading',
      disabled: 'addtocart-button-disabled',
      error: 'addtocart-button-error',
    };

    if (!el) return;

    this.el = el;
    this.el.classList.add(this.states.default);
  }

  setState(state) {
    if (!this.el) return;
    const keys = Object.keys(this.states);

    if (keys.indexOf(state) > -1) {
      keys.forEach(key => this.el.classList.remove(this.states[key]));
      this.el.classList.add(this.states[state]);
    }
  }

  resetState() {
    if (!this.el) return;
    const keys = Object.keys(this.states);

    keys.forEach(key => this.el.classList.remove(this.states[key]));
    this.el.classList.add(this.states.default);
  }
}
